import { useState, useEffect } from 'react';
import { headerNavItems } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-[72px] flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-vidicon-line text-background-50 text-lg"></i>
          </span>
          <span className="text-lg font-bold text-foreground-950 whitespace-nowrap">吃瓜视频</span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {headerNavItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors rounded-md cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>

        {mobileOpen && (
          <div className="md:hidden absolute top-[72px] left-0 right-0 bg-background-50 border-b border-background-200/60 py-2">
            {headerNavItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="block px-6 py-3 text-sm font-medium text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}